<template>
  <div class="w-full h-full flex flex-column justify-center items-center">
    <button
      class="close-folder"
      @click="activeDialog(true)"
      data-vs-button="activeDialog"
    >
      <zt-icon name="times" />
    </button>
    <div class="pb-4">
      <svg width="181" height="181" viewBox="0 0 160 181" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M160 100.5C160 101.669 159.974 102.828 159.925 103.984C158.887 128.213 147.073 149.649 129.153 163.625C115.592 174.201 98.5339 180.5 80 180.5C59.4449 180.5 40.7053 172.751 26.5371 160.01C16.6694 151.142 9.02204 139.857 4.52245 127.086C1.59347 118.766 0 109.819 0 100.5C0 56.3171 35.8171 20.5 80 20.5C106.811 20.5 130.54 33.6886 145.055 53.9302C153.153 65.2216 158.384 78.7073 159.683 93.3261C159.892 95.6869 160 98.0804 160 100.5Z" fill="#6C6C6C"/>
        <path d="M159.686 93.3261C142.742 92.673 98.2262 89.1138 99.418 82.2665C101.122 72.4771 149.204 76.7318 149.204 71.2004C149.204 65.669 125.802 71.2004 125.802 62.2665C125.802 56.9636 135.539 54.8085 145.057 53.9302C153.155 65.2216 158.386 78.7073 159.686 93.3261Z" fill="#F0EEEE"/>
        <path d="M35.4776 113.323C35.4776 119.275 15.4155 119.184 2.02449 118.462C0.698775 112.689 0 106.675 0 100.5C0 95.7261 0.417959 91.0469 1.22122 86.5016H1.22449C13.6718 87.7457 26.5404 90.5832 26.5404 96.3008C26.5404 104.81 1.86122 99.7065 1.86122 104.81C1.86122 109.917 35.4776 104.386 35.4776 113.323Z" fill="#F0EEEE"/>
        <path d="M129.15 163.625C115.589 174.201 98.531 180.5 79.9971 180.5C59.442 180.5 40.7024 172.751 26.5342 160.01C25.4795 159.063 24.451 158.087 23.4518 157.084C15.0665 148.712 8.53912 138.492 4.51953 127.086L45.0028 93.2085L75.6836 118.884L129.15 163.625Z" fill="#A2A0A0"/>
        <path d="M159.927 103.984C158.888 128.213 147.075 149.649 129.155 163.625C120.959 170.018 111.486 174.848 101.181 177.669C94.4346 179.514 87.3325 180.5 80.0019 180.5C59.4468 180.5 40.7072 172.751 26.5391 160.01L75.6884 118.884L126.709 76.1865L159.927 103.984Z" fill="#C8C6C6"/>
        <path d="M129.151 163.625C115.59 174.201 98.5323 180.5 79.9984 180.5C59.4433 180.5 40.7037 172.751 26.5356 160.01C25.4809 159.063 24.4523 158.087 23.4531 157.084L45.0041 93.2085L75.685 118.884L129.151 163.625Z" fill="#C8C6C6"/>
        <path d="M126.709 76.1865L101.181 177.669C94.4346 179.514 87.3325 180.5 80.0019 180.5C59.4468 180.5 40.7072 172.751 26.5391 160.01L75.6884 118.884L126.709 76.1865Z" fill="#A2A0A0"/>
        <g filter="url(#filter0_ddd)">
          <path d="M52.2062 67.9969C66.1583 66.0795 75.9143 53.2147 73.9969 39.2625C72.0795 25.3104 59.2147 15.5544 45.2626 17.4718C31.3104 19.3892 21.5544 32.254 23.4718 46.2062C25.3892 60.1583 38.254 69.9143 52.2062 67.9969Z" fill="#EFEDEE"/>
        </g>
        <path d="M60.3365 36.9089C59.6526 37.2544 58.8178 36.9806 58.472 36.2961L57.0868 33.5546C56.7413 32.8707 57.0158 32.0356 57.6996 31.6901C58.3834 31.3446 59.2186 31.6191 59.5641 32.3029L60.9493 35.0444C61.2951 35.7289 61.0203 36.5634 60.3365 36.9089Z" fill="#3A484A"/>
        <path d="M63.6441 39.3425L60.3302 41.0169C59.6463 41.3624 58.8112 41.0879 58.4657 40.4041C58.1202 39.7202 58.3947 38.8851 59.0785 38.5396L62.3924 36.8652C63.0769 36.5194 63.9114 36.7942 64.2569 37.478C64.6024 38.1618 64.3285 38.9966 63.6441 39.3425Z" fill="#F98084"/>
        <path d="M35.3052 49.5571C34.6214 49.9026 33.7865 49.6288 33.4407 48.9443L32.0555 46.2028C31.71 45.5189 31.9845 44.6838 32.6683 44.3383C33.3528 43.9924 34.1873 44.2673 34.5328 44.9511L35.918 47.6926C36.2638 48.3771 35.9897 49.2113 35.3052 49.5571Z" fill="#3A484A"/>
        <path d="M38.6206 51.9865L35.3067 53.6609C34.6223 54.0067 33.7878 53.7319 33.4422 53.0481C33.0967 52.3643 33.3706 51.5294 34.0551 51.1836L37.369 49.5092C38.0528 49.1637 38.8879 49.4382 39.2335 50.122C39.579 50.8059 39.3045 51.641 38.6206 51.9865Z" fill="#F98084"/>
        <path d="M49.4051 46.3626C48.1752 46.9841 46.7595 47.0524 45.5195 46.5509C44.8092 46.2637 44.4663 45.4543 44.7542 44.7437C45.0415 44.0333 45.8508 43.6904 46.5614 43.9783C47.0584 44.1792 47.6387 44.1454 48.1534 43.8854C48.6682 43.6253 49.0397 43.1782 49.1727 42.6589C49.3626 41.9161 50.1182 41.4683 50.861 41.6581C51.6033 41.8483 52.0514 42.6045 51.8612 43.3467C51.53 44.6421 50.635 45.7412 49.4051 46.3626Z" fill="#3A484A"/>
        <defs>
          <filter id="filter0_ddd" x="1.23145" y="0.231323" width="95.0062" height="97.0062" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="7"/>
            <feGaussianBlur stdDeviation="4"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="5"/>
            <feGaussianBlur stdDeviation="11"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
            <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="12"/>
            <feGaussianBlur stdDeviation="8.5"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
            <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape"/>
          </filter>
        </defs>
      </svg>
    </div>
    <div class="empty-legend text-zt-xl text-center pb-4">
      <p class="font-bold flex items-center mb-4 flex justify-center">
        <zt-icon name="folder" class="folder-icon mr-3" />
        {{folderName}} {{ $t('message.abm.folders.subFolderEmpty.label') }}
      </p>
      <p>{{ $t('message.abm.folders.subFolderEmpty.label1') }}</p>
    </div>
    <zt-button outlined @click="gotoCreateSubFolder" class="zt-button-color" data-vs-button="gotoCreateSubFolder">
      {{ $t('message.abm.folders.subFolderEmpty.buttonPrimary') }}
    </zt-button>
    <zt-button
        text
        class="text-zt-base mt-3 zt-button-custom"
        color="dark-300"
        @click="activeDialog(true)"
        data-vs-button="activeDialog"
    >
      {{ $t('message.abm.folders.subFolderEmpty.buttonSecondary') }}
    </zt-button>

    <cancel-sub-folder-dialog
      :active="cancel"
      :folder-name="folderName"
      :with-sub-folder="false"
    />
  </div>
</template>
<script>
import CancelSubFolderDialog from '@/modules/Folders/components/modals/CancelSubFolderDialog'
export default {
  name: 'SubFolderEmpty',
  components: {
    CancelSubFolderDialog
  },
  provide() {
    return {
      activeDialog: this.activeDialog
    }
  },
  props: {
    folderName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cancel: false
    }
  },
  methods: {
    activeDialog(active) {
      this.cancel = active
    },
    gotoCreateSubFolder() {
      this.$router.push({ name: 'subFolderCreate' })
    }
  }
}
</script>
<style scoped lang="scss">
.folder-icon {
  font-size: 21px;
}
.close-folder {
  font-size: 24px;
  line-height: 1;
  position: absolute;
  right: 33px;
  top: 25px;
  color: #707070;
}
.empty-legend {
  line-height: 1.75rem;
  color: #575757;
}
.button-create {
  font-size: 1rem;
  color: #4f41a3;
  border:1px #4f41a3 solid;
  &:hover {
    background: #6452D31D;
  }
}
.zt-button-color {
  color: #4f41a3 !important;
}
.zt-button-custom {
  color: #969696 !important;
}
</style>
